import React, { useState } from "react";
import getDay from "../function/getDay";
import getUrl from "../function/getUrl";
import checkLogin from "../function/checkLogin.js";

const EventExtendClassDate = () => {
  const url = getUrl();
  const token = sessionStorage.getItem("token");
  const [eventDate, setEventDate] = useState(getDay(0, "-"));
  const [eventName, setEventName] = useState("");
  const [extendDays, setExtendDays] = useState("7");
  const [candidates, setCandidates] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [resultView, setResultView] = useState(false);
  const [extendResult, setExtendResult] = useState(null);

  if (!checkLogin()) {
    window.location.href = "/logout";
  }

  const validateForm = () => {
    if (eventName.trim() === "") {
      alert("事件名稱不得空白");
      return false;
    }
    const days = Number(extendDays);
    if (!Number.isInteger(days) || days <= 0 || days > 60) {
      alert("延長天數必須是 1 到 60 的正整數");
      return false;
    }
    return true;
  };

  const buildQuery = () => {
    return `eventDate=${eventDate}&eventName=${encodeURIComponent(eventName.trim())}&extendDays=${extendDays}&token=${token}`;
  };

  const fetchCandidates = async (showMessage = true) => {
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    setMessage("");
    setResultView(false);
    setExtendResult(null);
    try {
      const data = await fetch(`${url}/appGet/getEventExtendCandidates?${buildQuery()}`).then((res) => res.json());
      if (data.msg) {
        setMessage(data.msg);
        setCandidates([]);
        setSelectedStudents({});
        return;
      }
      const nextSelectedStudents = {};
      data.forEach((item) => {
        if (item.canExtend) {
          nextSelectedStudents[item.studentDBID] = true;
        }
      });
      setCandidates(data);
      setSelectedStudents(nextSelectedStudents);
      if (showMessage) {
        setMessage(`符合條件名單 ${data.length} 筆，可延長 ${Object.keys(nextSelectedStudents).length} 筆`);
      }
    } catch (err) {
      console.error(err);
      setMessage("查詢失敗");
    } finally {
      setLoading(false);
    }
  };

  const selectedCount = candidates.filter((item) => item.canExtend && selectedStudents[item.studentDBID]).length;
  const canExtendCount = candidates.filter((item) => item.canExtend).length;
  const allSelected = canExtendCount > 0 && selectedCount === canExtendCount;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedStudents({});
      return;
    }
    const nextSelectedStudents = {};
    candidates.forEach((item) => {
      if (item.canExtend) {
        nextSelectedStudents[item.studentDBID] = true;
      }
    });
    setSelectedStudents(nextSelectedStudents);
  };

  const toggleStudent = (studentDBID) => {
    setSelectedStudents((prev) => {
      return {
        ...prev,
        [studentDBID]: !prev[studentDBID],
      };
    });
  };

  const executeExtend = async () => {
    if (!validateForm()) {
      return;
    }
    const studentDBIDList = candidates
      .filter((item) => item.canExtend && selectedStudents[item.studentDBID])
      .map((item) => item.studentDBID);
    if (studentDBIDList.length === 0) {
      alert("請至少選擇一位可延長學員");
      return;
    }
    const confirmText = `即將建立 0 元延長訂單\n事件日期：${eventDate}\n事件名稱：${eventName.trim()}\n延長天數：${extendDays}\n選取人數：${studentDBIDList.length}\n\n確認執行？`;
    if (!window.confirm(confirmText)) {
      return;
    }

    setLoading(true);
    const selectedCandidateMap = {};
    candidates.forEach((item) => {
      selectedCandidateMap[item.studentDBID] = item;
    });
    const formData = new FormData();
    formData.append("token", token);
    formData.append("eventDate", eventDate);
    formData.append("eventName", eventName.trim());
    formData.append("extendDays", extendDays);
    formData.append("studentDBIDList", studentDBIDList.join(","));
    try {
      const response = await fetch(`${url}/appPost/executeEventExtend`, {
        method: "POST",
        body: formData,
      });
      const responseText = await response.text();
      let data = {};
      try {
        data = responseText ? JSON.parse(responseText) : {};
      } catch (err) {
        data = { msg: responseText || "後端回應格式錯誤" };
      }
      if (!response.ok || data.result === "error") {
        setMessage(data.error ? `${data.msg || "執行延長失敗"}：${data.error}` : data.msg || "執行延長失敗");
        return;
      }
      await fetchCandidates(false);
      const successList = (data.details || [])
        .filter((item) => item.status === "success")
        .map((item) => {
          const candidate = selectedCandidateMap[item.studentDBID] || {};
          return {
            ...item,
            studentLastDate: candidate.studentLastDate || "",
            balance: candidate.balance || "",
          };
        });
      setExtendResult({
        eventDate,
        eventName: eventName.trim(),
        extendDays,
        successCount: data.successCount || 0,
        skipCount: data.skipCount || 0,
        failCount: data.failCount || 0,
        successList,
      });
      setResultView(true);
      setMessage("");
    } catch (err) {
      console.error(err);
      setMessage("執行延長失敗");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid pt-3">
      {loading && (
        <div
          className="position-fixed d-flex align-items-center justify-content-center"
          style={{
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.35)",
            zIndex: 2000,
          }}
        >
          <div className="text-center bg-white border rounded p-4">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div>系統處理中，請稍候</div>
          </div>
        </div>
      )}
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">事件延長期限</h5>
          {resultView && extendResult ? (
            <>
              <div className="alert alert-success mt-3">
                執行完成：成功 {extendResult.successCount} 筆，略過 {extendResult.skipCount} 筆，失敗 {extendResult.failCount} 筆
              </div>
              <div className="mb-3">
                <div>事件日期：{extendResult.eventDate}</div>
                <div>事件名稱：{extendResult.eventName}</div>
                <div>延長天數：{extendResult.extendDays}</div>
              </div>
              <button className="btn btn-outline-dark mb-3" onClick={() => setResultView(false)}>
                回到查詢名單
              </button>
              <table className="table table-striped table-sm">
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>有效期限</th>
                    <th>剩餘堂數</th>
                    <th>狀態</th>
                  </tr>
                </thead>
                <tbody>
                  {extendResult.successList.map((item) => {
                    return (
                      <tr key={item.studentDBID}>
                        <td>{item.name}</td>
                        <td>{item.studentLastDate}</td>
                        <td>{item.balance}</td>
                        <td className="text-success">成功</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col-12 col-md-3 mb-2">
                  <label>事件日期</label>
                  <input className="form-control" type="date" value={eventDate} onChange={(e) => setEventDate(e.target.value)} />
                </div>
                <div className="col-12 col-md-5 mb-2">
                  <label>事件名稱</label>
                  <input className="form-control" value={eventName} onChange={(e) => setEventName(e.target.value)} placeholder="例如：颱風停課" />
                </div>
                <div className="col-12 col-md-2 mb-2">
                  <label>延長天數</label>
                  <input className="form-control" type="number" min="1" max="60" value={extendDays} onChange={(e) => setExtendDays(e.target.value)} />
                </div>
                <div className="col-12 col-md-2 mb-2 d-flex align-items-end">
                  <button className="btn btn-primary mr-2" onClick={fetchCandidates} disabled={loading}>
                    查詢名單
                  </button>
                </div>
              </div>

              {message !== "" && <div className="alert alert-info mt-3">{message}</div>}

              <div className="mt-3 d-flex align-items-center">
                <button className="btn btn-outline-dark mr-2" onClick={toggleSelectAll} disabled={canExtendCount === 0}>
                  {allSelected ? "取消全選" : "全選可延長"}
                </button>
                <button className="btn btn-danger mr-2" onClick={executeExtend} disabled={loading || selectedCount === 0}>
                  執行延長
                </button>
                <span>已選 {selectedCount} / 可延長 {canExtendCount}</span>
              </div>

              <table className="table table-striped table-sm mt-3">
                <thead>
                  <tr>
                    <th>選取</th>
                    <th>姓名</th>
                    <th>有效期限</th>
                    <th>剩餘堂數</th>
                    <th>狀態</th>
                  </tr>
                </thead>
                <tbody>
                  {candidates.map((item) => {
                    return (
                      <tr key={item.studentDBID}>
                        <td>
                          <input
                            type="checkbox"
                            checked={!!selectedStudents[item.studentDBID]}
                            disabled={!item.canExtend}
                            onChange={() => toggleStudent(item.studentDBID)}
                          />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.studentLastDate}</td>
                        <td>{item.balance}</td>
                        <td className={item.canExtend ? "text-success" : "text-muted"}>{item.canExtend ? "可延長" : item.skipReason}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventExtendClassDate;
